import { render, staticRenderFns } from "./Msgone.vue?vue&type=template&id=4b65abda&scoped=true&"
import script from "./Msgone.vue?vue&type=script&lang=js&"
export * from "./Msgone.vue?vue&type=script&lang=js&"
import style0 from "./Msgone.vue?vue&type=style&index=0&id=4b65abda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65abda",
  null
  
)

component.options.__file = "Msgone.vue"
export default component.exports